window.slate = window.slate || {};
window.theme = window.theme || {};

function decorateList(list, nonRecursive) {
    if ($(list)) {
        if (typeof(nonRecursive) == 'undefined') {
            var items = $(list).select('li')
        }
        else {
            var items = $(list).childElements();
        }
        decorateGeneric(items, ['odd', 'even', 'last']);
    }
}

FindReact=function(e){let r=e[Object.keys(e).find(e=>e.startsWith("__reactInternalInstance$"))];return null==r?null:r.return?r._debugOwner?r._debugOwner.stateNode:r.return.stateNode:r._currentElement._owner._instance},jQuery(function(e){e(".bundle-builder-app--bundle--header-image").detach().removeClass("bundle-builder-app--bundle--header-image").wrap('<div id="category-img"/>').parent().insertBefore("section#main-container");const r=100;function t(){var t=e(".bundle-builder-app--bundle--product");t.each(function(){e(this).data("reactInstance",FindReact(this))});var n=t.map(function(r,t){return e(t).data("reactInstance").state.variant.product_id}).get();t.length>0&&e.get("/search?q="+n.map(e=>"id:"+e).join(" OR ")+"&view=preorder-data",function(n){var a=JSON.parse(n).variants_flat;function i(e){setTimeout(function(){var r=a.find(function(r){return r.variant_id==e.data("reactInstance").state.variant.id}).preorder_html;e.find(".mrk-preorder-message").html(r)},r)}t.each(function(){var r=e(this);e("<p/>").addClass("mrk-preorder-message").insertAfter(r.find(".bundle-builder-app--bundle--product-price")),i(r),r.find(".bundle-builder-app--bundle--product-options select").change(function(){i(r)})})})}function n(e){var r=e.text().match(new RegExp("\\[(.*)\\]"));return r?r[1]:null}t(),function n(){e(".bundle-builder-app--bundle--button--next,.bundle-builder-app--bundle--button--prev").click(function(){setTimeout(function(){t(),n()},r)})}();var a=e(".mrk-bundlebuilder-member").map(function(){return n(e(this))}).get();a.length>0&&e.get("/search?q="+a.join(" OR ")+"&view=preorder-data",function(r){var t=JSON.parse(r).variants_flat;e(".mrk-bundlebuilder-member").each(function(){var r=n(e(this)),a=t.find(function(e){return e.variant_sku==r}),i=void 0===a?"":a.preorder_html;i&&(e("<span/>").addClass("mrk-preorder-message mrk-preorder-bundle-member font12").text(i).insertBefore(e(this)),e("<br>").insertBefore(e(this)),e(".affirm-as-low-as").remove())}),e("[product-type='Custom Bundle']:has(.mrk-preorder-bundle-member)").each(function(){e(this).find(".mrk-preorder-product-level .mrk-preorder-message").html("To reserve your pre-order item, please note that credit card payments will be captured at the time that the order is placed.<br><br>If more than one item in your bundle is on pre-order, your order will ship on the latest pre-order ship date.<br><br>")})})});

_affirm_config={public_api_key:"PGFWS40UZI9YQSFW",script:"https://cdn1.affirm.com/js/v2/affirm.js"},function(e,t,n,r,f,i,o){var c,s=e[n]||{},a=document.createElement(i),m=document.getElementsByTagName(i)[0],u=function(e,t,n){return function(){e[t]._.push([n,arguments])}};for(s[r]=u(s,r,"set"),c=s[r],s[f]={},s[f]._=[],c._=[],s[f][o]=u(s,f,o),f=0,o="set add save post open empty reset on off trigger ready setProduct".split(" ");f<o.length;f++)c[o[f]]=u(s,r,o[f]);for(f=0,o=["get","token","url","items"];f<o.length;f++)c[o[f]]=function(){};a.async=!0,a.src=t[i],m.parentNode.insertBefore(a,m),delete t[i],c(t),e[n]=s}(window,_affirm_config,"affirm","checkout","ui","script","ready");

function newsletterSubscribe(){var t=jQuery("form.newsletter-zaius"),e=t.find(".footer-mrk-block-form-input");return zaius.subscribe({email:e.val(),list_id:"newsletter",source:"site footer field"}),swellAPI&&swellAPI.captureNewsletterSignup(e.val()),e.prop("disabled",!0),ga&&ga('send', 'event', 'Zaius', 'Footer Form Submission','Footer Newsletter Form'),t.find(".footer-mrk-block-form-btn").prop("disabled",!0).val("✓"),!1}var salesMotivator_i=0;function salesMotivatorExclusivity(){if(!(salesMotivator_i>30))if(salesMotivator_i++,"undefined"!=typeof shappify_motivator_goals&&0!==shappify_motivator_goals.length){var t=shappify_motivator_goals.clone().sort(function(t,e){return e.goal-t.goal});jQuery.getJSON("/cart.js",null,function(e){for(var a=e.items,r=0;r<t.length;r++)a.some(function(e){return e.variant_id==t[r].variant_id})&&(t[r].in_cart=!0);var i=[],o=!1;for(r=0;r<t.length;r++)t[r].in_cart&&(o?i.push(t[r].variant_id):o=!0);if(i.length>0){var n=i.reduce(function(t,e,a){return t+(0===a?"?":"&")+"updates["+e+"]=0"},"/cart/update");window.location.assign(n)}})}else setTimeout(salesMotivatorExclusivity,457)}salesMotivatorExclusivity();var gorgiasChatIntervalUI=window.setInterval(function(){window.GorgiasChat&&GorgiasChat.hasOwnProperty("open")&&(window.clearInterval(gorgiasChatIntervalUI),location.search.indexOf("chat")>-1&&GorgiasChat.open())},100),gorgiasChatInterval=window.setInterval(function(){var t=document.querySelector("#gorgias-chat-container #chat-window");if(t){var e=t.contentWindow.document.querySelector("head");if(e.children.length){window.clearInterval(gorgiasChatInterval);var a=document.createElement("style");a.textContent="",a.textContent+="div[role=region] div[role=region]:first-child .close-handle{position: absolute;top: 0;right: 0;z-index: 99;}",a.textContent+=".header-group h2 {font-size: 13px;font-weight: 400;}",e.appendChild(a)}}},100);jQuery(function(t){t(".shogun-root form[action=\\/cart\\/add]").each(function(e,a){var r=t(a).closest(".shg-product").attr("id");r=__shgProductInits.find(t=>t.uuid==r).productVariantId,t(a).append(t("<input>").addClass("mrk-shogun-ADA-cart").attr("type","hidden").attr("name","id").attr("value",r)).append(t("<input>").addClass("mrk-shogun-ADA-cart").attr("type","submit").attr("value","Add To Cart"))}),t("a.shogun-image-link video:only-child").each(function(e,a){var r=t(a).parent().attr("href").split("/"),i=r.pop();i||(i=r.pop()),i=i.split(".").shift().split("?").shift().replaceAll("-"," "),t("<span/>").text(i).addClass("mrk-shogun-ADA-gif").insertBefore(a)})});
jQuery(document).ready(function(){jQuery(".footer-mrk-links-wrapper .footer-mrk-links-main").click(function(){jQuery(this).hasClass("footer-link-active")?(jQuery(this).removeClass("footer-link-active"),jQuery(this).find(".triangle-top").hide(),jQuery(".footer-mrk-links-inner-wrapper").hide()):(jQuery(".footer-link-active").removeClass("footer-link-active"),jQuery(".triangle-top").hide(),jQuery(".footer-mrk-links-inner").hide(),jQuery(this).addClass("footer-link-active"),jQuery(this).find(".triangle-top").show(),jQuery(".footer-mrk-links-inner-wrapper").show(),jQuery(".footer-mrk-links-inner").eq(jQuery(this).index()).css("display","flex"))}),jQuery(".footer-mrk-links-wrapper-mobile .footer-mrk-links-main").click(function(){jQuery(this).hasClass("footer-link-active-mobile")?(jQuery(".footer-link-active-mobile").removeClass("footer-link-active-mobile"),jQuery(".footer-mrk-links-inner-mobile").hide()):(jQuery(".footer-link-active-mobile").removeClass("footer-link-active-mobile"),jQuery(".footer-mrk-links-inner-mobile").hide(),jQuery(this).addClass("footer-link-active-mobile"),jQuery(this).find(".footer-mrk-links-inner-mobile").css("display","flex"))})});


jQuery(document).ready(function() {
    

    var $topBanner = jQuery('.top-banner');

    // if ($topBanner.length) {
    //     //jQuery('body').css('margin-top', `${$topBanner.height() - 6}px`);
    //     $topBanner.show();

    //     if (sessionStorage.getItem('top-banner')) {
    //         $topBanner.hide();
    //         jQuery('body').css('margin-top', 0);
    //     }
    // }
    var IS_MOBILE_MENU_OPEN = false;
    // var SCROLL_POSITION;

    var toogleMobileMainMenu = function() {
        if (IS_MOBILE_MENU_OPEN) {
            jQuery('#chat-button').show();
            jQuery('#menutrigger').removeClass('first-click');
            jQuery('#mobile-menu-tree').removeClass('hide-panel');
            jQuery('#quick-access').removeClass('open');
            jQuery('.menu-wrapper').fadeOut();
            jQuery('.parent-category').removeClass('active');
            jQuery('body').removeClass('overflow-hidden');
            // jQuery(window).scrollTop(SCROLL_POSITION);
            closeMobileThirdLevelMenu();

            if (!sessionStorage.getItem('top-banner')) {
                $topBanner.show();
                jQuery('body').removeClass('no-margin');
                jQuery('html').removeClass('no-margin');
            }

        } else {
            jQuery('#chat-button').hide();
            jQuery('#menutrigger').addClass('first-click');
            jQuery('#quick-access').addClass('open');
            jQuery('.menu-wrapper').fadeIn();
            // SCROLL_POSITION = jQuery(window).scrollTop();

            jQuery('body').addClass('overflow-hidden');
            // jQuery('body').css('top', `-${SCROLL_POSITION}px`);

            if (!sessionStorage.getItem('top-banner')) {
                $topBanner.hide();
                jQuery('body').addClass('no-margin');
                jQuery('html').addClass('no-margin'); 
            } else {
                jQuery('body').removeClass('no-margin');
                jQuery('html').removeClass('no-margin');
            }
        }

        IS_MOBILE_MENU_OPEN = !IS_MOBILE_MENU_OPEN;
    }
   

    jQuery(window).on('scroll', function() {
        jQuery(".hidden-xs.nav").removeClass('hover');
        
     });

    var closeMobileThirdLevelMenu = function() {
        jQuery('.mobile-menu-sublevel .mobile-menu-subitems-list').removeClass('opened');
        jQuery('.mobile-menu-sublevel .mobile-menu-subitems-list').hide();
        jQuery('.mobile-menu-subtitle').removeClass('opened');
    }

    var handlMobileSubMenuOrder = function () {
        var $mainNavLinks = jQuery('#quick-access .arrow-level-open');

        $mainNavLinks.each(function(index, item) {
            var $sublinks = jQuery(item).find('.mobile-menu-sublevel');

            switch(index) {
                case 0:
                    var link = jQuery($sublinks[1]).find('a').addClass('show-all');
                    var newLink = link.clone();
                    newLink.appendTo(jQuery($sublinks[0]).find('.mobile-menu-subitems-list'));
                    jQuery($sublinks[0]).addClass('first-submenu');
                    link.remove();
                    jQuery($sublinks[1]).remove();

                    break;
                case 1:
                    var link = jQuery($sublinks[1]).find('a').addClass('show-all');
                    var alllinks = link.clone();
                    var otherLinks = jQuery($sublinks[2]).find('.mobile-menu-subitems-list a');
                    otherLinks.detach().appendTo(jQuery($sublinks[0]).find('.mobile-menu-subitems-list'));
                    alllinks.appendTo(jQuery($sublinks[0]).find('.mobile-menu-subitems-list'));
                    jQuery($sublinks[4]).find('a').detach().appendTo(jQuery($sublinks[3]).find('.mobile-menu-subitems-list'));
                    jQuery($sublinks[3]).find('.mobile-menu-subitems-list').addClass('no-border ');
                    jQuery($sublinks[0]).addClass('first-submenu');

                    jQuery($sublinks[4]).remove();
                    jQuery($sublinks[2]).remove();
                    jQuery($sublinks[1]).remove();

                    break;
                case 5: 
                    var link = jQuery($sublinks[1]).find('a').addClass('highlighted');
                    var newLink = link.clone();
                    newLink.appendTo(jQuery($sublinks[0]).find('.mobile-menu-subitems-list'));
                    jQuery($sublinks[4]).find('a').detach().appendTo(jQuery($sublinks[3]).find('.mobile-menu-subitems-list'));
                    jQuery($sublinks[1]).remove();
                    jQuery($sublinks[4]).remove();
                    jQuery($sublinks[0]).addClass('first-submenu');
                    break;
                case 6:
                    var otherLinks = jQuery($sublinks[1]).find('.mobile-menu-subitems-list a');
                    otherLinks.detach().appendTo(jQuery($sublinks[0]).find('.mobile-menu-subitems-list'));
                    jQuery($sublinks[0]).addClass('first-submenu hidden-border');

                    jQuery(jQuery($sublinks[2]).find('.mobile-menu-subitems-list').remove());
                    jQuery(jQuery($sublinks[3]).find('.mobile-menu-subitems-list').remove());
                    jQuery($sublinks[2]).find('.mobile-menu-subtitle').addClass('direct-link');
                    jQuery($sublinks[3]).find('.mobile-menu-subtitle').addClass('direct-link');
                    jQuery($sublinks[1]).remove();
                case 7:
                    var otherLinks = jQuery($sublinks[1]).find('.mobile-menu-subitems-list a');
                    otherLinks.detach().appendTo(jQuery($sublinks[0]).find('.mobile-menu-subitems-list'));
                    jQuery($sublinks[0]).addClass('first-submenu');

                    jQuery(jQuery($sublinks[2]).find('.mobile-menu-subitems-list').remove());
                    jQuery(jQuery($sublinks[3]).find('.mobile-menu-subitems-list').remove());
                    jQuery($sublinks[2]).find('.mobile-menu-subtitle').addClass('direct-link');
                    jQuery($sublinks[3]).find('.mobile-menu-subtitle').addClass('direct-link');
                    jQuery($sublinks[1]).remove();
            }

            jQuery($sublinks[$sublinks.length - 1]).find('.mobile-menu-subitems-list').addClass('no-border ');
        })
    }

    handlMobileSubMenuOrder();

    jQuery('.mobile-menu-subtitle').click(function(e) {
        var parentBlock = jQuery(this).parent().parent();

        if (jQuery(this).parent().find('.mobile-menu-subitems-list').length) {
            e.preventDefault();
        }

        if (jQuery(this).hasClass('opened')) {
            jQuery('.mobile-menu-subtitle').removeClass('opened');
        } else {
            jQuery('.mobile-menu-subtitle').removeClass('opened');           
            jQuery(this).addClass('opened');
        }

        var $allSubMenu = jQuery('.mobile-menu-subtitle').parent().find('.mobile-menu-subitems-list');
        var $submenu = jQuery(this).parent().find('.mobile-menu-subitems-list');
        $allSubMenu.slideUp();

        if ($submenu.hasClass('opened')) {
           $submenu.removeClass('opened');
           jQuery('#quick-access').addClass('prevent-scroll');
        } else {
            $allSubMenu.removeClass('opened');
            $submenu.addClass('opened');

            $submenu.slideDown(function() {
                if (jQuery(window).height() < parentBlock.height() + 50) {
                    jQuery('#quick-access').removeClass('prevent-scroll');
                }
            })
        }

    });

    jQuery('#menutrigger').click(400, function () {
        toogleMobileMainMenu();
    });

    jQuery('.nav-mobile-close').click(function (e) {
        toogleMobileMainMenu();
        jQuery('#quick-access').removeClass('prevent-scroll');
    });
    
    jQuery('.menu-wrapper').click(function (e) {
        toogleMobileMainMenu();
        jQuery('#quick-access').removeClass('prevent-scroll');
    });
    
    jQuery('.parent-cat').click(function() {
        jQuery(this).next().addClass('active');
        var $item = jQuery(this).next().find('.mobile-menu-sublevel');
        jQuery($item[0]).find('.mobile-menu-subtitle').click();
        jQuery('#mobile-menu-tree').addClass('hide-panel');
        jQuery('#quick-access').addClass('prevent-scroll');
        jQuery("#quick-access").scrollTop(0);
    });

    ['click','keydown'].forEach(e => {
        jQuery('.back-to-parent').on(e, function(event) {
            // // Unless Enter
            // if (event.keyCode !== 13) return;

            jQuery('#mobile-menu-tree').removeClass('hide-panel');
            jQuery('#quick-access').removeClass('prevent-scroll');
            jQuery('.parent-category').removeClass('active');
            closeMobileThirdLevelMenu();
        });
    });

    jQuery('.top-banner-close').click(function (e) {
        e.preventDefault()
        $topBanner.hide();
        sessionStorage.setItem('top-banner', true);
        jQuery('body').css('margin-top', 0);
        jQuery('body').addClass('no-margin');
    });

    jQuery('.level-top.hasSublinks, .submenu-container').hover(function () {
        jQuery('.hidden-xs.nav').addClass('hover');
    }, function () {
        jQuery('.hidden-xs.nav').removeClass('hover');
    });

    var $headerDesktopMenuTitles = jQuery('.desktop-menu > li');

    jQuery('.desktop-menu > li > a').click(function(e) {
        if (jQuery(this).attr('href') == '#') {
            e.preventDefault();
        }
    })

    // 6 main menu templates
    $headerDesktopMenuTitles.each(function(index, item) {
        var columns = jQuery(item).find('.submenu-columns');

        switch(index) {
            case 0:
                jQuery(item).find('.block-1').addClass('no-magin');
                jQuery(item).find('.block-1').detach().appendTo(columns[0]);
                jQuery(item).find('.block-2').find('.subheader-title').removeClass('subheader-title');
                jQuery(item).find('.block-2').detach().appendTo(columns[0]);
                jQuery(item).find('.block-3').detach().appendTo(columns[1]);
                jQuery(item).find('.block-4').detach().appendTo(columns[2]);
                jQuery(item).find('.block-5').detach().appendTo(columns[2]);
                jQuery(item).find('.block-6').detach().appendTo(columns[3]);
                jQuery(item).find('.block-7').detach().appendTo(columns[3]);
                break;
            case 1:
                jQuery(item).find('.block-1').addClass('no-magin');
                jQuery(item).find('.block-1').detach().appendTo(columns[0]);
                jQuery(item).find('.block-2').find('.subheader-title').removeClass('subheader-title');
                jQuery(item).find('.block-2').detach().appendTo(columns[0]);
                jQuery(item).find('.block-3 li:first-child').css('visibility', 'hidden');
                jQuery(item).find('.block-3').detach().appendTo(columns[1]);
                jQuery(item).find('.block-4').addClass('no-magin');
                jQuery(item).find('.block-4').detach().appendTo(columns[2]);
                jQuery(item).find('.block-5').find('.subheader-title').removeClass('subheader-title');
                jQuery(item).find('.block-5').detach().appendTo(columns[2]);
                break;
            case 2:
                jQuery(item).find('.block-1').detach().appendTo(columns[0]);
                jQuery(item).find('.block-2').detach().appendTo(columns[1]);
                jQuery(item).find('.block-3').detach().appendTo(columns[2]);
                jQuery(item).find('.block-4').detach().appendTo(columns[2]);
                jQuery(item).find('.block-5').detach().appendTo(columns[3]);
                break;
            case 5:
                jQuery(item).find('.block-1').detach().appendTo(columns[0]);
                jQuery(item).find('.block-2').detach().appendTo(columns[0]);
                jQuery(item).find('.block-3').detach().appendTo(columns[1]);
                jQuery(item).find('.block-4').addClass('no-magin');
                jQuery(item).find('.block-4').detach().appendTo(columns[2]);
                jQuery(item).find('.block-5').find('.subheader-title').removeClass('subheader-title');
                jQuery(item).find('.block-5').detach().appendTo(columns[2]);
                jQuery(item).find('.block-6').detach().appendTo(columns[2]);
                jQuery(item).find('.block-7').detach().appendTo(columns[3]);
                jQuery(item).find('.block-8').detach().appendTo(columns[3]);
                break;
            case 6:
                jQuery(item).find('.block-1').detach().appendTo(columns[0]);
                jQuery(item).find('.block-2  li:first-child').css('visibility', 'hidden');
                jQuery(item).find('.block-2').detach().appendTo(columns[1]);
                jQuery(item).find('.block-3').addClass('margin-b-30');
                jQuery(item).find('.block-3').detach().appendTo(columns[2]);
                jQuery(item).find('.block-4').detach().appendTo(columns[2]);
                jQuery(columns[4]).find('.static-container:first-child').detach().appendTo(columns[3]);
                break;
            case 7:
                jQuery(item).find('.block-1').detach().appendTo(columns[0]);
                jQuery(item).find('.block-2  li:first-child').css('visibility', 'hidden');
                jQuery(item).find('.block-2').detach().appendTo(columns[1]);
                jQuery(item).find('.block-3').addClass('margin-b-30');
                jQuery(item).find('.block-3').detach().appendTo(columns[2]);
                jQuery(item).find('.block-4').detach().appendTo(columns[2]);
                jQuery(columns[4]).find('.static-container:first-child').detach().appendTo(columns[3]);
                break;
        }
    });
})